<div class="container mx-auto p-6">
  <h2 class="text-2xl font-bold mb-4">Carga Masiva de Resultados</h2>
  <div class="flex justify-between items-center mb-4">
    <button class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded" (click)="volver()" >Volver</button>
  <div class="bg-gray-100 p-6 rounded-lg shadow-md">
    <input
      type="file"
      (change)="onFileChange($event)"
      accept=".xlsx, .xls"
      class="mb-4"
    />

    <p class="text-gray-700 mb-4">{{ mensaje }}</p>

    <button
      (click)="cargarResultados()"
      [disabled]="cargando"
      class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
    >
      {{ cargando ? 'Cargando...' : 'Cargar Resultados' }}
    </button>
  </div>
</div>
